import React from "react";
import styles from "./partner.module.css";
import { Outlet, useLoaderData, useOutletContext } from "@remix-run/react";
import { ProductProps } from "~/modules/Product/Product.type";
import FloatingButtonCart from "~/modules/catalogue/components/FloattingButtonCart/FloatingButtonCart";
import { isEmpty, WidgetCaller } from "@commons-monorepo/index";
import CatalogueMainProducts from "~/modules/catalogue/components/CatalogueMainProducts/CatalogueMainProducts";
import EmptyState from "~/components/empty-states/empty-state/empty-state";
import { useCart } from "~/modules/cart/providers/cart.provider";
import { InternalView } from "~/components/internal-view";
import { useTranslation } from "react-i18next";
import { useGlobalStyles } from "~/styles/context/global-styles-wrapper";

export default function Index(props: ProductProps) {
  const { paginatedData } = useLoaderData();
  const context = useOutletContext<any>();
  const { theme } = useGlobalStyles();
  const { storeMetadata } = useOutletContext<any>();
  const { cartProducts, removeProduct, manuallyChangeProduct, addProduct } =
  useCart();
  const cart = {
    cartProducts,
    removeProduct,
    manuallyChangeProduct,
    addProduct
  };
  const localConfig = {
    cart: cart,
    locale: storeMetadata?.locale,
    currency: storeMetadata?.currency
  };
  const products = paginatedData?.products || [];
  const { t } = useTranslation();

  return (
    <>
      <div className={styles.wrapperMainCatalogue} role='catalogue'>
        <InternalView
          copy={t("main_header.all_products")}
          breadcrumbs={[{ text: t("main_header.all_products") }]}>

          <div className={styles.desktopGrid}>
            <div>{cartProducts.length >= 1 && <FloatingButtonCart />}</div>
            {!isEmpty(products) ?
            <CatalogueMainProducts
              data={products}
              localConfig={localConfig}
              theme={theme}
              caller={WidgetCaller.CatalogueAllProducts}
              withoutPaddingX /> :


            <EmptyState searchProduct />}

          </div>
        </InternalView>
        <Outlet
          context={{
            ...context,
            ...paginatedData
          }} />

      </div>
    </>);

}